import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState, actions } from '../store';
import { IonPage, IonItem, IonCardContent, IonCard, IonCardSubtitle,
  IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar,
} from '@ionic/react';
import { Alert } from '../store/alerts/types';
// import Map from '../components/CampMap';


type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  alerts: any;
  list: any,
};

class AlertsDetails extends React.Component<Props, State> {
  defaultState: State = {
    alerts: [],
    list: {},
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
  }

  componentWillMount = async () => {
    const {
      match,
    } = this.props;
    await this.props.getAlertsByCode(match.params.id);
  }

  handleAccordion(index: number) {
    const list = {};
    Object.keys(this.state.list).forEach((item) => {
      list[item] = false;
    });
    this.setState({
      ...this.state,
      list: {
        ...list,
        [index]: !this.state.list[index],
      },
    });
  }

  render() {
    const { match, loadedAlerts, parkMap } = this.props;
    const parkCode = match.params.id;
    const parkName = parkMap[parkCode] && parkMap[parkCode].name;
    const alerts = loadedAlerts[parkCode];
    const UNKNOWN = '???';
    return (
      <IonPage className="campground-details">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={match.url.replace('/alerts', '')} />
            </IonButtons>
            <IonTitle>{parkName} Alerts</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonCard>
          { alerts && alerts.map((item: Alert, index: number) => {
            return (
              <IonItem key={`camp-${index}`} onClick={() => { this.handleAccordion(index) } }>
                <IonCardContent key={'camp'+index} className="width100" >
                  <IonCardSubtitle className="width100" >
                    {item.title}
                  </IonCardSubtitle>
                  <div></div>
                  <div className={this.state.list[index] ? 'noLeftPadding grayBg slider' : 'slider closed' }>
                    <IonCardContent>
                      <div>{item.description}</div>
                      <div>({item.category})</div>
                      <a href={item.url}>{item.url}</a>
                    </IonCardContent>
                    
                  </div>
                </IonCardContent>
              </IonItem>
            )
          })}
          </IonCard>
        </IonContent>
      </IonPage>
    );
  }
  
}

const mapDispatchToProps = {
  getAlertsByCode: (parkCode: string) => actions.alerts.getAlertsByCode(parkCode),
  // searchPlaces: (searchText: string, page: number) => actions.places.getPlaces(searchText, page),
}

const mapStateToProps = (state: RootState) => ({
  parkMap: state.places.parkMap,
  loadedAlerts: state.alerts.loadedAlerts,
  parkName: state.alerts.parkName,
  parkCode: state.alerts.parkCode,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertsDetails)
